module.exports = __webpack_public_path__ + "media/images/service/c_9-9ef16097bc2b3bbb58707e7e55b98e75.png";